export const textAlignMap = {
  start: 'text-start',
  center: 'text-center',
  end: 'text-end',
};
